import { post, get } from '@/utils/request';

const url = {
  uploadAgreeBookSign: '/healthy/auth/providerStore/uploadAgreeBookSign',
  getAgreeBook: '/healthy/auth/providerStore/getAgreeBook',
  getSupplierImgAgreeBook: '/healthy/auth/supplierImg/getAgreeBook',
};

export default {
  uploadAgreeBookSign(params = {}, options = {}) {
    return post({
      url: url.uploadAgreeBookSign,
      data: params,
      options,
    });
  },
  getAgreeBook(params = {}, options = {}) {
    return post({
      url: url.getAgreeBook,
      data: params,
      options,
    });
  },
  getSupplierImgAgreeBook(params = {}, options = {}) {
    return post({
      url: url.getSupplierImgAgreeBook,
      data: params,
      options,
    });
  },
};
